import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ReplaySubject, takeUntil } from 'rxjs';
import { Slide } from '../core/Type/okeeycash-slide.interface';
import { OkeeyCashSliderComponent } from '../okeey-cash-slider/okeey-cash-slider.component';

@Component({
  selector: 'tutorial-okeey-cash',
  templateUrl: './tutorial-okeey-cash.component.html',
  styleUrl: './tutorial-okeey-cash.component.scss',
  standalone: true,
  imports: [OkeeyCashSliderComponent]
})
export class TutorialOkeeyCashComponent implements OnInit, OnDestroy {
  public lang: string;
  public slides: Slide[];
  private readonly _onDestroy$: ReplaySubject<void>;

  constructor(private _translateService: TranslateService) {
    this._onDestroy$ = new ReplaySubject<void>(1);
    this.lang = this._translateService.currentLang;
    this.slides = this._getSlides();
  }

  public ngOnInit(): void {
    this._setLangListener();
  }

  public ngOnDestroy(): void {
    this._onDestroy$.next();
    this._onDestroy$.complete();
  }

  private _setLangListener(): void {
    this._translateService.onLangChange.pipe(takeUntil(this._onDestroy$)).subscribe(() => {
      this.lang = this._translateService.currentLang;
      this.slides = this._getSlides();
    });
  }

  private _getSlides(): Slide[] {
    return [
      {
        title: 'okeeyCash.tutorial.preferredLanguage',
        descriptionStart: 'okeeyCash.tutorial.preferredLanguageDescription',
        img: '/assets/img/my-okeey-cash/tutorial/preferred-language.svg'
      },
      {
        title: 'okeeyCash.tutorial.accessPermission',
        descriptionStart: 'okeeyCash.tutorial.accessPermissionDescription',
        img: '/assets/img/my-okeey-cash/tutorial/location-access.svg'
      },
      {
        title: 'okeeyCash.tutorial.referralCode',
        descriptionStart: 'okeeyCash.tutorial.referralCodeDescriptionStart',
        value: 'okeeyCash.tutorial.referralCodeValue',
        descriptionEnd: 'okeeyCash.tutorial.referralCodeDescriptionEnd',
        img: '/assets/img/my-okeey-cash/tutorial/referral-code.svg'
      },
      {
        title: 'okeeyCash.tutorial.mobileNumber',
        descriptionStart: 'okeeyCash.tutorial.mobileNumberDescription',
        img: '/assets/img/my-okeey-cash/tutorial/mobile-number.svg'
      },
      {
        title: 'okeeyCash.idDocument.title',
        descriptionStart: 'okeeyCash.tutorial.idDocumentDescriptionStart',
        value: 'okeeyCash.tutorial.idDocumentValue',
        descriptionEnd: 'okeeyCash.tutorial.idDocumentDescriptionEnd',
        img: '/assets/img/my-okeey-cash/tutorial/id-document.svg'
      },
      {
        title: 'okeeyCash.selfieTime',
        descriptionStart: 'okeeyCash.tutorial.selfieDescription',
        img: '/assets/img/my-okeey-cash/tutorial/selfie-time.svg'
      },
      {
        title: 'okeeyCash.personalDetail',
        descriptionStart: 'okeeyCash.tutorial.personalDetailDescription',
        img: '/assets/img/my-okeey-cash/tutorial/personal-details.svg'
      },
      {
        title: 'okeeyCash.yourPassword',
        descriptionStart: 'okeeyCash.tutorial.yourPasswordDescriptionStart',
        value: 'okeeyCash.tutorial.yourPasswordValue',
        step: ['okeeyCash.tutorial.characters', 'okeeyCash.tutorial.number', 'okeeyCash.tutorial.specialCharacter'],
        descriptionEnd: 'okeeyCash.tutorial.yourPasswordDescriptionEnd',
        img: '/assets/img/my-okeey-cash/tutorial/your-password.svg'
      },
      {
        title: 'okeeyCash.tutorial.termsAndCondition',
        subTitleStart: 'okeeyCash.tutorial.termsAndConditionSubText',
        descriptionStart: 'okeeyCash.tutorial.termsAndConditionDescriptionStart',
        value: 'okeeyCash.tutorial.termsAndConditionDescriptionValue',
        descriptionEnd: 'okeeyCash.tutorial.termsAndConditionDescriptionEnd',
        img: '/assets/img/my-okeey-cash/tutorial/terms-&-condition.svg',
        link: `https://usa.okeeycash.com/${this.lang}/conditions`
      }
    ];
  }
}
